import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

export function SignaturePad({ onChange, testid = "signature-pad" }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const points = useRef(0);
  const [empty, setEmpty] = useState(true);
  useEffect(() => {
    const c = ref.current; const r = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * r; c.height = c.offsetHeight * r;
    const ctx = c.getContext("2d");
    ctx.scale(r, r); ctx.lineWidth = 2.4; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#0B1F3A";
  }, []);
  const pos = (e) => { const b = ref.current.getBoundingClientRect(); return [e.clientX - b.left, e.clientY - b.top]; };
  const down = (e) => { e.preventDefault(); ref.current.setPointerCapture?.(e.pointerId); drawing.current = true; const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext("2d"); ctx.lineTo(...pos(e)); ctx.stroke(); points.current += 1; };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    if (points.current > 8) { setEmpty(false); onChange(ref.current.toDataURL("image/png")); }
  };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); points.current = 0; setEmpty(true); onChange(null); };
  return (
    <div className="space-y-1.5">
      <div className="relative rounded-xl border-2 border-dashed border-slate-300 bg-white overflow-hidden">
        <canvas ref={ref} data-testid={testid} className="w-full h-44 touch-none cursor-crosshair block" onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up} />
        <div className="absolute left-6 right-6 bottom-9 border-b border-slate-300 pointer-events-none" />
        {empty && <span className="pointer-events-none absolute inset-0 flex items-center justify-center text-sm text-slate-400">Assine aqui com o dedo ou o mouse</span>}
      </div>
      <button type="button" onClick={clear} data-testid={`${testid}-clear`} className="inline-flex items-center gap-1 text-xs text-slate-500 hover:text-slate-900"><Eraser className="h-3.5 w-3.5" />Limpar assinatura</button>
    </div>
  );
}
